import { AppContext, Navigation } from "Core";
import { GlobalSearch } from "Service/Client";
import { IDisposable } from "Core/Interfaces";
import { computePosition, offset, shift } from "@floating-ui/dom";
import { GlobalSearchService, TextBlockService } from "Service";

/**
 * @hidden
 */
export class GlobalSearchControl implements IDisposable {
    private static buttonTemplate = require("./Templates/GlobalSearchControl.html").default;

    private _kendoElement: kendo.ui.AutoComplete;
    private globalSearchModel: kendo.data.ObservableObject;

    private popup: JQuery<HTMLElement>;

    constructor(private globalSearchService: GlobalSearchService, private textBlockService: TextBlockService) {}

    initialize(jQueryElement: JQuery<HTMLElement>) {
        this.globalSearchModel = kendo.observable({
            ...AppContext.current.appViewModel,
        });

        let elem = $(GlobalSearchControl.buttonTemplate);
        jQueryElement.prepend(elem);

        this.popup = jQueryElement.find(".dms-globalsearch-wrapper");
        const input = jQueryElement.find(".dms-globalsearch-control");

        const button = jQueryElement.find(".dms-globalsearch-button");
        button.on("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.popup.toggleClass("dms-hidden");
            computePosition(button[0], this.popup[0], {
                middleware: [offset({ mainAxis: 8 }), shift({ padding: 4 })],
                placement: "left-start",
            }).then(({ x, y }) => {
                this.popup.css({ top: y, left: x });
            });
        });

        let dataSourceOptions: kendo.data.DataSourceOptions = {
            serverFiltering: true,
            transport: {
                read: (options: kendo.data.DataSourceTransportRead) => {
                    if (options.data && options.data.filter && options.data.filter.filters && options.data.filter.filters.length > 0) {
                        this.globalSearchService.search(options.data.filter.filters[0].value, "", "").then((result) => {
                            try {
                                (options.success as JQuery.Ajax.SuccessCallback<any>)(result, null, null);
                            } catch (e) {
                                console.log(e);
                            }
                        });
                    } else {
                        (options.success as JQuery.Ajax.SuccessCallback<any>)([], null, null);
                    }
                },
            },
            schema: {
                groups: function (data: GlobalSearch[]) {
                    return data;
                },
                data: function (data: GlobalSearch[]) {
                    return data;
                },
                total: function (data: GlobalSearch[]) {
                    return data.length;
                },
            },
            group: { field: "Category" },
        };
        kendo.bind(elem, this.globalSearchModel);

        this.textBlockService.getAll().then(() => {
            let options: kendo.ui.AutoCompleteOptions = {
                dataTextField: "Text",
                valuePrimitive: true, // sets the binding to the value field instead of the dataitem itself
                suggest: false,
                filter: "contains",
                enforceMinLength: true,
                minLength: 1,
                clearButton: false,
                placeholder: this.textBlockService.get("GlobalSearchPlaceholder", "userdata", true),
                dataSource: new kendo.data.DataSource(dataSourceOptions),
                select: (e) => this.onSelect(e),
                dataBound: (e) => this.onDataBound(e),
                template: `<span class="k-state-default"><strong>#: data.Text #</strong><p class="m-0">#: (data.Description || "") #</p></span>`,
            };
            this._kendoElement = new kendo.ui.AutoComplete(input[0], options);
        });
    }

    private onDataBound(e: kendo.ui.AutoCompleteDataBoundEvent): void {
        let fixedHeader = this._kendoElement.list.find(".k-group-header");
        let text = fixedHeader.text();
        fixedHeader.hide();
        this._kendoElement.list.find("li:first").append(`<div class="k-group">${text}</div>`);
    }

    private onSelect(e: kendo.ui.AutoCompleteSelectEvent): void {
        const item = <GlobalSearch>e.dataItem;
        Navigation.navigate(item.Link);
        e.sender.value("");
        e.preventDefault();
        this.popup.addClass("dms-hidden");
    }

    dispose(): void {
        if (this._kendoElement) {
            this._kendoElement.destroy();
        }
    }
}
